// extracted by mini-css-extract-plugin
export default {"defaultAvatar":"KHHBBwzhxbhbU_zUM1Pj","background":"G6wK9UHtzHwoBYZV7NwH","icon":"hTOa0BPuTTjtXUkKPcLD"};